<div class="card-container" [ngStyle]="{ 'background': pickedBackground ? pickedBackground : 'white' }">
    <div
        class="profile-section top-section"
    >
        <div class="header-row">
            <span class="header-text" [ngStyle]="getOnLeaveStatusOpacity()">{{ (isPrimaryYouthWorker ? "Primary Youth Worker" : "Secondary Youth Worker") | translate }}</span>
            <span [ngStyle]="getOnLeaveStatusTagStyle()" class="on-leave-tag">{{"On Leave" | translate}}</span>
        </div>
        <div class="top-section-content" [ngStyle]="getOnLeaveStatusOpacity()">
            <div class="top-section-img-container">
                <img [src]="avatarUrl" *ngIf="avatarUrl" class="avatarImage"/>
                <img
                    *ngIf="noAvatarUrlFound && !avatarUrl"
                    class="avatar-svg"
                    src="../../../../assets/account-circle.svg"
                />
            </div>
                <div class="top-section-info" [ngStyle]="getOnLeaveStatusOpacity()">
                    <div class="youth-worker-name">
                        {{youthWorkerData.firstName}} {{youthWorkerData.lastName}}
                    </div>

                    <div class="youth-worker-tag">
                        {{ youthWorkerData.jobTitle | translate }}
                    </div>

                    <div class="info-rows">
                        <div class="info-row">
                            <div class="info-row-label">
                                {{ "Email" | translate }}:
                            </div>
                            <a
                                class="info-row-value green-color"
                            >
                            {{ youthWorkerData.email }}
                            </a>
                        </div>
                        <div class="info-row">
                            <div class="info-row-label">
                                {{ "Phone" | translate }}:
                            </div>
                            <a
                                class="info-row-value green-color"
                            >
                            {{ youthWorkerData.phone | phoneFormat }}
                            </a>
                        </div>
                        <div class="info-row bio-row">
                            <div class="info-row-label">
                                {{ "Bio" | translate }}:
                            </div>
                            <div class="info-row-value">
                                <!-- {{ profile.biography }} --> 
                                {{ youthWorkerData.biography }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

    </div>
</div>
